import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  admin: {
    onboardRequests: []
  },
  neofintech: {
    phase1: {
      countries: [],
      companyLocations: [],
      requesterCompanyTypes: [],
      economicSectors: [],
      businessSectors: [],
      capitalProgramTypes: [],
      fundraisingProgramTypes: [],
      programBeneficiaries: [],
    },
    phase2: {
      programCurrencyTypes: [],
      requestedAmountRanges: [],
      sellsAmountRanges: [],
      ebidtaSign: [],
      ebidtaAmountRanges: [],
      sellsForecast: [],
      hasAccountAuditor: [],
    },
    chosenLocation: {
      lng: null,
      lat: null,
      locality: null,
      country: null
    },
    userData: {
      userId: null,
      firstName: null,
      lastName: null,
      jobPosition: null,
      companyName: null,
      jobCity: null,
      jobCountry: null,
      contactPhone: null,
      email: null
    },
    email: null,
    status: null,
    code: null,
    candidates: [],
    ccRecipients: [],
    contactMethod: null,
    requestId: null,
    createdAt: null,
    updatedAt: null,
    phase: null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}